export const NOTES = {
  LOAD: 'NOTES_LOAD',
  LOAD_DONE: 'NOTES_LOAD_DONE',
  LOAD_FAILED: 'NOTES_LOAD_FAILED',
};

export const load = (entity, id, page) => ({ type: NOTES.LOAD, entity, id, page });



// WEBPACK FOOTER //
// ./src/actions/notes.js